// extracted by mini-css-extract-plugin
export var modal = "_ub-0";
export var table = "_ub-1";